import React, { FC } from 'react';
import { AdminTable } from '../components/table/AdminTable';
import { AdminToolbar } from '../components/toolbar/AdminToolbar';
import { AdminToolbarTitle } from '../components/toolbar/AdminToolbarTitle';
import { useTransactionColumns } from './hooks/useTransactionColumns';
import { useTranslation } from 'react-i18next';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { QueryKey } from '../api/queryClient';
import { getTransactions } from './getTransactions';
import { Transaction } from './types/Transaction';
import { TransactionsContextProvider } from './TransactionsContext';

export const Transactions: FC = () => {
  const { t } = useTranslation();
  const columns = useTransactionColumns();
  const { isLoading, data = [] } = useQuery<Transaction[]>({
    queryKey: [QueryKey.Transactions],
    queryFn: ({ signal }) => getTransactions(signal),
    placeholderData: keepPreviousData,
  });

  return (
    <TransactionsContextProvider>
      <AdminToolbar>
        <AdminToolbarTitle>{t('Transactions')}</AdminToolbarTitle>
      </AdminToolbar>

      <AdminTable items={data} loading={isLoading} columns={columns} />
    </TransactionsContextProvider>
  );
};
